
import { Component, Prop, Vue } from "vue-property-decorator";
import { AuthenticationContext } from "vue-adal";
import axios from "axios";
import { EventBus } from "./helpers/EventBus";
import Dashboards from "./views/Dashboards.vue";
import UserStatics from "./views/UserStatics.vue";
@Component({
  components: {
    //Dashboards,
   // UserStatics
  }
})
export default class App extends Vue {
  public profile: any = {};
  public hostnameMode: string = "ers";
  @Prop() private msg!: string;
  private static interceptorId: number | null = null;

  public changeMode() {
    Vue.prototype.$hostMode = this.hostnameMode;
    localStorage.hostMode = this.hostnameMode;
    if (
      this.hostnameMode === "geniebot" &&
      ["spellingdictionaries", "blankpresentation", "palette"].includes(
        this.$route.name as string
      )
    ) {
      this.$router.push({ name: "acl" });
    }
    EventBus.$emit("mode-changed", this.hostnameMode);
  }

  public mounted() {
    this.profile = AuthenticationContext.user?.profile ?? {};
    this.hostnameMode = localStorage.hostMode ? localStorage.hostMode : "ers";
    Vue.prototype.$hostMode = this.hostnameMode;
    const resource = process.env.VUE_APP_ADAL_APPID;

    // Set up axios interceptor — eject previous one first to prevent stacking
    if (App.interceptorId !== null) {
      axios.interceptors.request.eject(App.interceptorId);
    }
    App.interceptorId = axios.interceptors.request.use(
      (config) => {
        const token = AuthenticationContext.adalContext.getCachedToken(resource);
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        config.baseURL = process.env.VUE_APP_API_BASE_URL;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    AuthenticationContext.acquireToken(resource, (err, token) => {
      if (err) {
        const errCode = err.split(":")[0];
        switch (errCode) {
          case "AADSTS50058": // Need to prompt for user sign in
            AuthenticationContext.login();
            break;
          case "AADSTS65001": // Token is invalid; grab a new one
            AuthenticationContext.acquireTokenRedirect(resource);
            break;
          case "AADSTS16000": // No Access
            AuthenticationContext.login();
            break;
          default:
            // Local ADAL error (e.g. "Could not get token") — do NOT redirect,
            // otherwise we get an infinite login loop.
            console.warn("ADAL acquireToken warning:", err);
            break;
        }
        return;
      }
    });
  }

  public logout() {
    AuthenticationContext.logout();
  }
}
